import { useMemo } from 'react';

import FullBuyAnalytics from '~/src/features/full-buy/analytics';
import FullBuyProvider from '~/src/features/full-buy/analytics/context';
import { FullBuy as FullBuySteps } from '~/src/features/full-buy/indexByPage';

type TFullBuyProps = {
    isVillage: boolean,
}

const FullBuy = ({ isVillage }: TFullBuyProps): JSX.Element | null => {
    const analytics = useMemo(() => new FullBuyAnalytics(isVillage ? 'fullbuy_village' : 'fullbuy'), [isVillage]);

    return (
        <FullBuyProvider analytics={analytics} isVillage={isVillage}>
            <FullBuySteps />
        </FullBuyProvider>
    );
};

export default FullBuy;
